import {
    CAP_SERVICE_GROUP_DELETED,
    CAP_SERVICE_GROUP_SAVED,
    CAP_SERVICE_GROUPS_LOADED,
    CAP_SERVICE_GROUPS_LOADING
} from "./actionTypes";
import axios from "axios";
import {getConfig} from "./authActions";
import {returnAllErrorsAsPopup, returnErrors} from "./errorActions";
import {getSuccess} from "./successActions";

export const loadCapServiceGroups = () => (dispatch, getState) => {
    dispatch({type: CAP_SERVICE_GROUPS_LOADING});
    axios
        .get(process.env.REACT_APP_API_URL + '/capServiceGroups', getConfig(getState))
        .then(res =>
            dispatch({
                type: CAP_SERVICE_GROUPS_LOADED,
                payload: res.data
            })
        )
        .catch(err => {
            dispatch(returnErrors(err));
        });
};


export const saveOrUpdateCapServiceGroup = (capServiceGroup, onSuccessCallback) => (dispatch, state) => {
    dispatch({type: CAP_SERVICE_GROUPS_LOADING});
    axios
        .post(process.env.REACT_APP_API_URL + '/capServiceGroups', capServiceGroup, getConfig(state))
        .then(res => {
                dispatch({type: CAP_SERVICE_GROUP_SAVED});
            }
        )
        .then(() => {
            dispatch(getSuccess({success: "CAP сервис сохранен"}))
        })
        .then(() => {
            onSuccessCallback && onSuccessCallback()
        })
        .catch(err => {
            dispatch(returnAllErrorsAsPopup(err));
        });
};

export const deleteCapServiceGroup = (id, onSuccessCallback) => (dispatch, state) => {
    dispatch({type: CAP_SERVICE_GROUPS_LOADING});
    axios
        .delete(process.env.REACT_APP_API_URL + '/capServiceGroups/' + id, getConfig(state))
        .then(res => {
                dispatch({type: CAP_SERVICE_GROUP_DELETED});
            }
        )
        .then(() => {
            dispatch(getSuccess({success: "CAP сервис удален"}))
        })
        .then(() => {
            onSuccessCallback && onSuccessCallback()
        })
        .catch(err => {
            dispatch(returnAllErrorsAsPopup(err));
        });
};